import { Modal, Button, Icon, Text } from "@artprov/design-system";
import PropTypes from "prop-types";

/**
 * Modal de confirmación para asignar embargos judiciales
 *
 * @param {Object} props
 * @param {boolean} props.open - Estado de apertura del modal
 * @param {Function} props.setOpen - Función para cambiar el estado de apertura
 * @param {Array} props.selectedRows - Filas seleccionadas para asignar
 * @param {Function} props.onConfirm - Callback al confirmar (recibe selectedRows)
 */
export default function ModalAsignar({ open, setOpen, selectedRows, onConfirm }) {
    const totalCount = selectedRows.length;

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        if (totalCount > 0) {
            onConfirm?.(selectedRows);
        }
    };

    const title = totalCount === 1 ? "Asignar embargo al juicio" : "Asignar embargos a juicios";

    // Determinar mensaje según cantidad
    const getMessage = () => {
        if (totalCount === 1) {
            return "Si lo asignás, se vinculará un registro al juicio correspondiente.";
        }
        return `Si los asignás, se vincularán ${totalCount} registros a los juicios correspondientes.`;
    };

    return (
        <Modal.Container
            open={open}
            setOpen={setOpen}
            closeOnClickOutside={false}
            onClose={handleClose}
        >
            <Modal.Content height="auto" width="408px" className="gap-6">
                <Modal.Header className="relative flex items-center justify-center">
                    <div className="flex flex-col items-center">
                        <Icon
                            variant="notification success"
                            className="mb-6"
                            size="extra-large"
                        />
                        <Modal.Title className="text-center text-[24px] tracking-[0.25px]">
                            {title}
                        </Modal.Title>
                    </div>
                    <div className="absolute right-0 top-0">
                        <Modal.Close onClose={handleClose} />
                    </div>
                </Modal.Header>

                <Text variant="Body-M" className="text-center tracking-[0.1px]">
                    {getMessage()}
                </Text>

                <Modal.Footer className="flex justify-center">
                    <div className="flex gap-4">
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={handleClose}
                        >
                            Volver
                        </Button>
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={handleConfirm}
                            isDisabled={totalCount === 0}
                            classNames={{
                                label: "text-tertiary-100"
                            }}
                        >
                            Asignar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal.Content>
        </Modal.Container>
    );
}

ModalAsignar.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    selectedRows: PropTypes.array.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
